/**
 * Snapshot of the 3D view (Game HUD is DOM on top — not captured).
 * Capture uses an offscreen render target and `readRenderTargetPixels`, so the main WebGL
 * context does not need `preserveDrawingBuffer`.
 * The capture itself only produces a PNG `Blob`; deciding what to do with it
 * (native share sheet, download fallback, …) is the caller's responsibility.
 */

export type WebGlCaptureOptions = {
    mimeType?: string
    cropToShareCard?: boolean
    // Supersample the offscreen capture (1 = screen resolution)
    exportScale?: number
}

type CaptureFn = (opts?: WebGlCaptureOptions) => Promise<Blob | null>

let captureImpl: CaptureFn | null = null

export function registerWebGlCanvasCapture(fn: CaptureFn | null): void {
    captureImpl = fn
}

export function isWebGlCanvasCaptureAvailable(): boolean {
    return captureImpl != null
}


// Renders the current 3D card to an offscreen target and returns it as a PNG `Blob`. Returns `null` when no renderer is mounted or the capture fails.

export async function captureWebGlCanvasPng(
    opts?: WebGlCaptureOptions,
): Promise<Blob | null> {
    if (!captureImpl) {
        console.warn('[WebGL capture] No renderer registered yet')
        return null
    }
    return captureImpl({ mimeType: 'image/png', ...opts })
}
